import './Footer.scss';

import React from 'react';

function Footer() {
    return (
        <footer>
            <div className="site-footer">
                Footer
            </div>
        </footer>
    );
}

export default Footer;